export default __webpack_public_path__ + "static/media/safetypic1.c9d8e351.jpg";